import styled from 'styled-components';

export const InvestmentDetailsCardStyles = styled.div`
	overflow: hidden;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	border-radius: 0.5rem;

	&.borderless {
		border: 0;
		border-radius: 0;

		.header,
		.content,
		.label {
			border: 0;
			padding: 0;
		}
	}

	.header {
		min-height: 3.375rem;
	}

	.header,
	.label {
		padding: 0.5rem;
	}

	.content {
		border-top: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	}
`;
